<template>
  <div class="container" v-loading="isLoading">
    <div class="bar">
      <ods-tabs v-model="activeTab">
         <ods-row :gutter="8" style="margin: 25px 21px 0 21px;">
            <modulo-comercio
            @finalLoader="finalHandlerloader"
            @finalTpv="finalHandlerTpv"
            @finalListMov="finalHandlerListMov"
            @finalregistrosTotales="finalHandlerRegTotales"
            @finalPrimeraPag="finalPrimeraPa"
            @finalListadoPorDefect="finalListadoPorDef"/>
          </ods-row>
        <ods-tab-pane label="usuarios" name="usuarios">
            <div class="usuarios-table">
              <usuarios-table :usu="mostrarUsu" :codcomercio="comercio"></usuarios-table>
            </div>
        </ods-tab-pane>
        <ods-tab-pane label="terminales" name="terminales">
            <div class="terminales-table">
              <terminales-table :tpv="mostrarTpv" :codcomercio="comercio" :desdescomercio="descomercio"></terminales-table>
            </div>
        </ods-tab-pane>
        <ods-tab-pane label="movimientos" name="movimientos">
            <div class="movimientos-table">
              <movimientos-table :movimientos="mostrarMovimientos" :comercio="comercio" :descomercio="descomercio" :numComercio="numComercio" :numeroCadena="registroNumeroCadena" :numeroComercio="registroNumeroComercio" :regTotales="regTotales" :listadoVuelta="listadoVuelta" :primero="primero"></movimientos-table>
            </div>
        </ods-tab-pane>
      </ods-tabs>
    </div>
      <dialog-generic-error
      :message="errorMessage"
      :dialogError="dialogError"
      :before-close-fn="handleCloseSession"
      @dialogClosed="closeDialogError($event)">
      </dialog-generic-error>
  </div>
</template>

<script>
import TerminalesTable from '@/components/cadena/TerminalesTable'
import MovimientosTable from '@/components/cadena/MovimientosTable'
import DashboardComercioSeleccionable from '@/components/dashboard/DashboardComercioSeleccionable'
import UsuariosPorComercioTable from '@/components/usuarios/UsuariosPorComercioTable'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      comercios: '',
      dialogError: false,
      hasErrors: false,
      errorMessage: '',
      comercio: '',
      descomercio: '',
      isLoading: false,
      cadena: '',
      mostrarTpv: true,
      mostrarUsu: true,
      mostrarMovimientos: true,
      registroNumeroCadena: 0,
      registroNumeroComercio: 0,
      activeTab: '',
      avanzar: 'false',
      retroceder: 'false',
      totalRegistros: 0,
      indMasDatos: 'N',
      claveInicio: '',
      claveFin: '',
      pantPagina: '',
      regTotales: 0,
      peticionListAct: false,
      pagActual: 1,
      listadoVuelta: {},
      numComercio: 1,
      primero: JSON.parse(sessionStorage.getItem('appPagina')).pagina
    }
  },
  components: {
    'modulo-comercio': DashboardComercioSeleccionable,
    'terminales-table': TerminalesTable,
    'movimientos-table': MovimientosTable,
    'usuarios-table': UsuariosPorComercioTable,
    DialogGenericError
  },
  computed: {
    ...mapGetters({
      isLoadingUsers: 'isLoadingUsers',
      isLoadingTPVs: 'isLoadingTPVs',
      fatalErrorHolding: 'hasHoldingError'
    })
  },
  methods: {
    executeUsers () {
      this.$store.dispatch('listUsers', this.comercio).then(r => {
        this.executeTpvs()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          if (r.vacio === true) {
            this.mostrarUsu = false
          } else {
            this.mostrarUsu = true
          }
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    executeTpvs () {
      this.$store.dispatch('listTpv', { codcom: this.comercio }).then(r => {
        this.executeListProfile()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          if (r.vacio === true) {
            this.mostrarTpv = false
          } else {
            this.mostrarTpv = true
          }
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    executeListProfile () {
      this.$store.dispatch('listProfile').then(r => {
        this.executeVisorTpvs()
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    executeVisorTpvs () {
      this.$store.dispatch('listVisorTPVS', { codcom: this.comercio }).then(r => {
        this.executeListMovimientos()
        this.isLoading = false
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in list TPVS - App', e)
      })
    },
    executeListMovimientos () {
      if (this.peticionListAct === true && this.$route.query.l.davanzar !== undefined) {
        this.avanzar = this.$route.query.l.davanzar
        this.retroceder = this.$route.query.l.dretroceder
        this.indMasDatos = this.$route.query.l.dindMasDatos
        this.claveInicio = this.$route.query.l.dclaveInicio
        this.claveFin = this.$route.query.l.dclaveFin
        this.pantPagina = this.$route.query.l.dpantPagina
        this.peticionListAct = false
      } else {
        this.avanzar = false
        this.retroceder = false
        this.indMasDatos = ''
        this.claveInicio = ''
        this.claveFin = ''
        this.pantPagina = ''
        this.pagActual = 1
        const paramsPagina = JSON.stringify({
          pagina: this.pagActual
        })
        sessionStorage.setItem('appPagina', paramsPagina)
      }
      const data = {
        dcodcom: this.comercio,
        davanzar: this.avanzar,
        dretroceder: this.retroceder,
        dindMasDatos: this.indMasDatos,
        dclaveInicio: this.claveInicio,
        dclaveFin: this.claveFin,
        dpantPagina: this.pantPagina
      }
      this.$store.dispatch('listMovimientos', data).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          if (r.vacio === true) {
            this.mostrarMovimientos = false
          } else {
            this.mostrarMovimientos = true
          }
        }
        var clave = r.data.runServiceResponse.return.claveInicio
        var pos = 0
        pos = clave.indexOf('/')
        this.regTotales = parseInt(clave.substring(pos + 1))
      }).catch(e => {
        console.error('Error in list Movimientos - App', e)
      })
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    finalHandlerloader (load) {
      this.isLoading = load
    },
    finalHandlerTpv (loadTpv) {
      this.mostrarTpv = loadTpv
    },
    finalHandlerListMov (loadTpv) {
      this.mostrarMovimientos = loadTpv
    },
    finalHandlerRegTotales (loadReg) {
      this.regTotales = loadReg
    },
    finalPrimeraPa (load) {
      this.primero = load
    },
    finalListadoPorDef (load) {
      this.listadoVuelta = load
    },
    paginacion () {
      if (this.$route.query.mov === true) {
        this.listadoVuelta = {
          dcodcom: this.comercio,
          davanzar: this.$route.query.l.davanzar,
          dretroceder: this.$route.query.l.dretroceder,
          dindMasDatos: this.$route.query.l.dindMasDatos,
          dclaveInicio: this.$route.query.l.dclaveInicio,
          dclaveFin: this.$route.query.l.dclaveFin,
          dpantPagina: this.$route.query.l.dpantPagina
        }
      } else {
        this.listadoVuelta = {
          dcodcom: this.comercio,
          davanzar: 'false',
          dretroceder: 'false',
          dindMasDatos: '',
          dclaveInicio: '',
          dclaveFin: '',
          dpantPagina: 0
        }
      }
    },
    volverAComercio () {
      if (this.$route.query.mov === true) {
        const storageAppDataCadenaComercio = JSON.parse(sessionStorage.getItem('appCadenaComercio'))
        this.comercio = storageAppDataCadenaComercio.comercio
        this.descomercio = storageAppDataCadenaComercio.descomercio
        document.getElementsByClassName('modulo')[storageAppDataCadenaComercio.numComercio - 1].classList.add('active')
        this.isActive = true
      } else {
        const paramsCadenaComercio = JSON.stringify({
          comercio: this.comercio,
          descomercio: this.descomercio,
          numComercio: this.numComercio
        })
        sessionStorage.setItem('appCadenaComercio', paramsCadenaComercio)
        document.getElementsByClassName('modulo')[this.numComercio - 1].classList.add('active')
        this.isActive = true
      }
    }
  },
  mounted () {
    const storageAppData = JSON.parse(sessionStorage.getItem('appCadena'))
    if (storageAppData.cadena === '') {
      const paramsCadena = JSON.stringify({
        cadena: this.$route.query.cadena
      })
      sessionStorage.setItem('appCadena', paramsCadena)
    }
    if (this.$route.query.cadena === '[object Object]' || this.$route.query.cadena === undefined) {
      this.$route.query.cadena = ''
    } else {
      this.storageAppData = JSON.parse(sessionStorage.getItem('appCadena'))
      if (this.$route.query.cadena.codcadenal !== this.storageAppData.cadena.codcadenal) {
        const paramsCadena = JSON.stringify({
          cadena: this.$route.query.cadena
        })
        sessionStorage.setItem('appCadena', paramsCadena)
      }
    }
    const dataCadena = {
      cadena: this.$route.query.cadena || JSON.parse(sessionStorage.getItem('appCadena'))
    }
    if (dataCadena.cadena.codcadenal === undefined) {
      dataCadena.cadena = dataCadena.cadena.cadena
    }
    if (this.$route.query.mov === true) {
      if (this.$route.query.tab === '0') {
        this.activeTab = 'usuarios'
      } else if (this.$route.query.tab === '1') {
        this.activeTab = 'terminales'
      } else if (this.$route.query.tab === '2') {
        this.activeTab = 'movimientos'
      }
      this.peticionListAct = true
    } else {
      this.activeTab = 'usuarios'
      this.peticionListAct = false
    }
    this.$store.dispatch('listCommercialFijo', dataCadena.cadena.codcadenal).then(r => {
      this.registroNumeroCadena = dataCadena.cadena.registro_Numero
      this.comercios = this.$store.getters.getlistCommercialFijoData
      this.comercio = this.comercios[0].codcom
      this.descomercio = this.comercios[0].descomercio
      this.numComercio = this.comercios[0].registro_Numero
      this.executeUsers()
      this.volverAComercio()
      this.paginacion()
      if (r.error === true) {
        this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
      }
    }).catch(e => {
      console.error('Error in list Users - App', e)
    })
    this.isLoading = true
  }
}
</script>
<style lang="scss" scoped>

.container {
  background-color: $--color-neutral-4;
    min-height: 100vh
}

.terminales-table {
margin: rem(20) rem(25) rem(25) rem(25);
}

.usuarios-table {
margin: rem(20) rem(25) rem(25) rem(25);
}

.movimientos-table {
margin: rem(20) rem(25) rem(25) rem(25);
}

/deep/ .ods-tabs__nav-scroll {
  background-color:$--color-white;
  padding: 10px 20px 20px 30px;
}

.example-slide {
    align-items: center;
    background-color: #666;
    color: #999;
    display: flex;
    font-size: 1.5rem;
    justify-content: center;
    min-height: 10rem;
  }
</style>
